import { render, staticRenderFns } from "./CustomerPricesImportPopup.vue?vue&type=template&id=ac6bea6a&"
import script from "./CustomerPricesImportPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerPricesImportPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports